module.exports = __webpack_public_path__ + "img/content-cut_white.4d9cea4c.svg";